<template>
  <div>
    <div class="ts-flex ts-justify-between">
      <label class="ts-shadow-rounded ts-uppercase ts-p-2 ts-rounded-md">{{
        $t('saleContract.item')
      }}</label>
      <a
        href="#"
        class="ts-shadow-rounded ts-uppercase ts-px-4 ts-rounded-md ts-bg-blue-400 ts-text-white ts-flex ts-items-center ts-no-underline hover:ts-no-underline"
        style="height: 35px"
        @click.prevent="getProductBalance"
      >
        <span class="ts-mr-2">{{ $t('saleContract.getBalance') }}</span>
        <i class="fas fa-balance-scale"></i>
      </a>
    </div>
    <!-- <div class="ts-border ts-border-blue-600 ts-rounded ts-pr-2 ts-pl-2 ts-pb-2"> -->
    <div class="max-h">
      <table class="ts-w-full ts-mt-2">
        <thead>
          <tr>
            <th
              class="ts-uppercase ts-border ts-px-2 ts-py-1 ts-border-gray-300"
            >
              {{ $t('saleContract.no') }}
            </th>
            <th
              class="ts-uppercase ts-border ts-px-2 ts-py-1 ts-border-gray-300"
            >
              {{ $t('saleContract.product') }}
            </th>
            <th
              class="ts-uppercase ts-border ts-px-2 ts-py-1 ts-border-gray-300 ts-w-24 ts-whitespace-no-wrap"
            >
              {{ $t('saleContract.qtyInStock') }}
            </th>
            <th
              class="ts-uppercase ts-border ts-px-2 ts-py-1 ts-border-gray-300 ts-w-24"
            >
              {{ $t('saleContract.quantity') }}
            </th>
            <th
              class="ts-uppercase ts-border ts-px-2 ts-py-1 ts-border-gray-300 ts-w-24"
            >
              {{ $t('saleContract.uom') }}
            </th>
            <!-- <th
              class="ts-uppercase ts-border ts-px-2 ts-py-1 ts-border-gray-300 ts-w-24"
            >
              {{ $t('saleContract.uThb') }}
            </th> -->
            <th
              class="ts-uppercase ts-border ts-px-2 ts-py-1 ts-border-gray-300 ts-w-24"
            >
              {{ $t('saleContract.unitPrice') }}
            </th>
            <th
              class="ts-uppercase ts-border ts-px-2 ts-py-1 ts-border-gray-300 ts-w-32"
            >
              {{ $t('saleContract.amount') }}
            </th>
            <!-- <th
              class="
                ts-uppercase
                ts-border
                ts-px-2
                ts-py-1
                ts-border-gray-300
                ts-w-48
              "
            >
              {{ $t('saleContract.remark') }}
            </th> -->
            <th
              class="ts-uppercase ts-border ts-px-2 ts-py-1 ts-text-center ts-w-16"
            >
              {{ $t('actions') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(detail, index) in model.item_list" :key="index">
            <td class="ts-px-2 ts-py-1 ts-w-6 ts-text-center">
              {{ index + 1 }}
            </td>
            <td class="ts-px-2 ts-py-1">
              <p class="ts-mb-0 ts-font-extrabold ts-text-blue-600">
                <i class="fab fa-product-hunt"></i> {{ detail.product_name_en }}
              </p>
              <p class="ts-mb-0">
                <i class="fas fa-barcode"></i> {{ detail.barcode }}
              </p>
              <p class="ts-mb-0 ts-text-red-600">
                <i class="fas fa-map-pin"></i>
                {{ detail.storage_location ? detail.storage_location : 'N/A' }}
              </p>
            </td>
            <td
              valign="top"
              class="ts-text-center ts-cursor-pointer"
              @click.prevent="showBalance(detail)"
            >
              <a-tooltip placement="top" class="ts-cursor-pointer">
                <template #title>
                  <span>Check Balance Other Warehouses</span>
                </template>
                <input
                  type="text"
                  v-model="detail.balance"
                  class="form-control"
                  readonly
                />
              </a-tooltip>
            </td>
            <td valign="top">
              <input
                v-model.number="detail.quantity"
                type="number"
                class="form-control"
                @input="calculate"
                @keypress.enter="onQtyEnter(index)"
              />
              <div
                class="validate"
                v-if="errors.has('item_list.' + index + '.quantity')"
              >
                {{ errors.first('item_list.' + index + '.quantity') }}
              </div>
            </td>
            <td valign="top">
              <a-select
                ref="uom"
                v-model="detail.uom_id"
                class="ts-w-full"
                :class="{
                  'is-invalid': errors.has('item_list.' + index + '.uom_id')
                }"
                @change="onUomChange(detail)"
                @keydown.native.enter="onUomEnter(index)"
              >
                <a-select-option
                  v-for="(u, index) in getUom(detail.product_id)"
                  :key="index"
                  :value="u.uom_id"
                  >{{ u.uom_name_en }}
                </a-select-option>
              </a-select>
              <div
                class="validate"
                v-if="errors.has('item_list.' + index + '.uom_id')"
              >
                {{ errors.first('item_list.' + index + '.uom_id') }}
              </div>
            </td>
            <!-- <td valign="top" class="ts-w-32">
              <ts-currency-input
                v-model.number="detail.amount_in_bath"
                @input="onThbInput(detail)"
                currency="฿"
                class="form-control ts-text-right"
              />
              <div
                class="validate"
                v-if="errors.has('item_list.' + index + '.amount_in_bath')"
              >
                {{ errors.first('item_list.' + index + '.amount_in_bath') }}
              </div>
            </td> -->
            <td valign="top" class="ts-w-32">
              <ts-currency-input
                v-model.number="detail.unit_price"
                class="form-control ts-text-right"
                @input="onUpUsdInput(detail)"
                :currency="default_currency_sign"
              />
              <div
                class="validate"
                v-if="errors.has('item_list.' + index + '.unit_price')"
              >
                {{ errors.first('item_list.' + index + '.unit_price') }}
              </div>
            </td>
            <td valign="top">
              <ts-currency-input
                v-model="detail.amount"
                disabled
                class="form-control ts-text-right"
                :currency="default_currency_sign"
              />
            </td>
            <!-- <td valign="top">
              <input
                v-model.trim="detail.remarks"
                type="text"
                class="form-control"
                @keypress.enter="onRemarkEnter(index)"
              />
              <div
                class="validate"
                v-if="errors.has('item_list.' + index + '.remarks')"
              >
                {{ errors.first('item_list.' + index + '.remarks') }}
              </div>
            </td> -->
            <td class="ts-text-center ts-space-x-3" valign="top">
              <a
                v-if="model.customer_id != null"
                href="#"
                class="ts-text-blue-700"
                @click.prevent="viewPrice(detail)"
              >
                <i class="fa fa-dollar-sign ts-mt-2"></i>
              </a>
              <a
                href="#"
                class="ts-text-red-600"
                @click.prevent="removeRow(detail)"
              >
                <i class="fa fa-trash ts-mt-2"></i>
              </a>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="9" class="ts-border-t ts-border-blue-600"></td>
          </tr>
          <tr>
            <td class="ts-px-2 ts-py-1" colspan="3">
              <span class="ts-font-extrabold"
                >Row #: {{ $formatNumber(numRow) }}</span
              >
            </td>
            <td class="ts-px-2 ts-py-1 ts-font-extrabold ts-text-red-600">
              QTY: {{ $formatNumber(countQty) }}
            </td>
            <td class="ts-px-2 ts-py-1 ts-text-right">
              <span class="ts-font-extrabold ts-text-red-600">TOTAL : </span>
            </td>
            <!-- <td
              class="ts-px-2 ts-py-1 ts-text-right ts-font-extrabold ts-text-red-600"
            >
              {{
                sumTHBPrice ? $defaultCurrencyWithCode(sumTHBPrice, 'THB', 'th-TH') : 0
              }}
            </td> -->
            <td
              class="ts-px-2 ts-py-1 ts-text-right ts-font-extrabold ts-text-red-600"
            >
              {{ sumUSDPrice ? $defaultCurrencyWithCode(sumUSDPrice) : 0 }}
            </td>
            <td
              class="ts-px-2 ts-py-1 ts-text-right ts-font-extrabold ts-text-red-600"
            >
              {{
                totalAmountUSDPrice ? $defaultCurrencyWithCode(totalAmountUSDPrice) : 0
              }}
            </td>
            <td colspan="3"></td>
          </tr>
          <tr>
            <td colspan="2" rowspan="5" valign="top">
              <textarea
                v-model.trim="model.remark"
                rows="5"
                class="form-control"
                :placeholder="$t('wholesale.remark')"
              ></textarea>
            </td>
            <td colspan="3"></td>
            <td class="ts-text-right">
              <div
                class="ts-bg-blue-600 ts-text-white ts-w-full ts-float-right ts-p-2 ts-rounded-sm ts-uppercase"
              >
                <b>{{ $t('saleContract.vatRate') }}</b>
              </div>
            </td>
            <td class="ts-text-right">
              <!-- <b class="ts-text-blue-600">{{
                model.vat_rate ? model.vat_rate : 0
              }}</b> -->
              <input
                type="text"
                :value="model.vat_rate"
                disabled
                class="ts-text-blue-600 ts-text-right ts-p-2 ts-border ts-border-gray-300 ts-rounded ts-w-full ts-outline-none ts-font-bold"
              />
            </td>
            <td colspan="3"></td>
          </tr>
          <tr>
            <td colspan="3"></td>
            <td class="ts-text-right">
              <div
                class="ts-bg-blue-600 ts-text-white ts-w-full ts-float-right ts-p-2 ts-rounded-sm ts-uppercase"
              >
                <b>{{ $t('saleContract.vatAmount') }}</b>
              </div>
            </td>
            <td class="ts-text-right">
              <ts-currency-input
                v-model="model.vat_amount"
                class="ts-text-blue-600 ts-text-right ts-p-2 ts-border ts-border-gray-300 ts-rounded ts-w-full ts-outline-none ts-font-bold"
                disabled
                :currency="default_currency_sign"
              />
              <!-- <b class="ts-text-blue-600">{{
                model.vat_amount ? model.vat_amount : 0
              }}</b> -->
            </td>
            <td colspan="3"></td>
          </tr>
          <tr>
            <td colspan="3"></td>
            <td class="ts-text-right">
              <div
                class="ts-bg-blue-600 ts-text-white ts-w-full ts-float-right ts-p-2 ts-rounded-sm ts-uppercase ts-whitespace-no-wrap"
              >
                <b>{{ $t('saleContract.totalExcludevat') }}</b>
              </div>
            </td>
            <td class="ts-text-right">
              <!-- <b class="ts-text-blue-600">{{
                model.total_exclude_vat
                  ? $defaultCurrencyWithCode(model.total_exclude_vat)
                  : 0
              }}</b> -->
              <ts-currency-input
                v-model="model.total_exclude_vat"
                class="ts-text-blue-600 ts-text-right ts-p-2 ts-border ts-border-gray-300 ts-rounded ts-w-full ts-outline-none ts-font-bold"
                disabled
                :currency="default_currency_sign"
              />
            </td>
            <td colspan="3"></td>
          </tr>
          <tr>
            <td colspan="3"></td>
            <td class="ts-text-right">
              <div
                class="ts-bg-blue-600 ts-text-white ts-w-full ts-float-right ts-p-2 ts-rounded-sm ts-uppercase ts-whitespace-no-wrap"
              >
                <b>{{ $t('saleContract.totalDeposit') }}</b>
              </div>
            </td>
            <td class="ts-text-right">
              <!-- <b class="ts-text-blue-600">{{
                model.deposit_amount ? $defaultCurrencyWithCode(model.deposit_amount) : 0
              }}</b> -->
              <ts-currency-input
                v-model="model.deposit_amount"
                class="ts-text-blue-600 ts-text-right ts-p-2 ts-border ts-border-gray-300 ts-rounded ts-w-full ts-outline-none ts-font-bold"
                disabled
                :currency="default_currency_sign"
              />
            </td>
            <td colspan="3"></td>
          </tr>
          <tr>
            <td colspan="3"></td>
            <td class="ts-text-right">
              <div
                class="ts-bg-blue-600 ts-text-white ts-w-full ts-float-right ts-p-2 ts-rounded-sm ts-uppercase ts-whitespace-no-wrap"
              >
                <b>{{ $t('saleContract.grandTotal') }}</b>
              </div>
            </td>
            <td class="ts-text-right">
              <!-- <b class="ts-text-blue-600">{{
                model.grand_total ? $defaultCurrencyWithCode(model.grand_total) : 0
              }}</b> -->
              <ts-currency-input
                v-model="model.grand_total"
                class="ts-text-blue-600 ts-text-right ts-p-2 ts-border ts-border-gray-300 ts-rounded ts-w-full ts-outline-none ts-font-bold"
                disabled
                :currency="default_currency_sign"
              />
            </td>
            <td colspan="3"></td>
          </tr>
        </tfoot>
      </table>
      <a-modal
        v-if="show_modal_sold_price"
        v-model="show_modal_sold_price"
        :footer="null"
        :zIndex="1020"
        :maskClosable="false"
        style="left: 100px"
        width="650px"
        :title="
          selectedProduct
            ? selectedProduct.barcode +
              '|' +
              selectedProduct.product_name_en +
              ' (' +
              '$ ' +
              selectedProduct.cost +
              '|' +
              '฿ ' +
              selectedProduct.cost * this.thbRate +
              ')'
            : 'N/A'
        "
      >
        <SoldPrice
          v-model="model"
          :selectedProduct="selectedProduct"
          @priceChange="priceChange()"
        />
      </a-modal>
      <a-modal
        v-if="show_modal_balance"
        v-model="show_modal_balance"
        :footer="null"
        :zIndex="1020"
        :maskClosable="false"
        width="400px"
        :title="
          !show_modal_balance_loading
            ? balanceOtherLocation.length > 0
              ? balanceOtherLocation[0].product_name_kh
              : ''
            : ''
        "
      >
        <div class="ts-space-y-3">
          <ts-loading-banner :loading="show_modal_balance_loading">
            <div
              class="ts-flex ts-justify-between ts-border-b"
              v-for="(b, index) in balanceOtherLocation"
              :key="index"
            >
              <div>
                {{ b.location_name_en }}
                {{ b.storage_name_en ? '(' + b.storage_name_en + ')' : '' }}
              </div>
              <div>
                {{ b.ending_balance }}
              </div>
            </div>
          </ts-loading-banner>
        </div>
      </a-modal>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import { includes } from 'lodash'
import ProductList from './product-list.vue'
import SoldPrice from './sold-price.vue'

export default {
  name: 'ItemDetails',
  props: ['value', 'validate'],
  components: {
    ProductList,
    SoldPrice
  },
  data () {
    return {
      errors: new Errors(),
      show_modal_sold_price: false,
      show_modal_balance: false,
      show_modal_balance_loading: false,
      model: {},
      balances: [],
      balanceOtherLocation: [],
      selectedProduct: [],
      newRow: {
        product_id: '',
        uom_id: '',
        quantity: 1,
        unit_price: '',
        remarks: '',
        amount: 0,
        amount_in_bath: 0,
        storage_location: null,
        product_name_en: null,
        barcode: null,
        balance: 'no refresh'
      }
    }
  },
  computed: {
    ...mapState('wholesale/saleContract', ['edit_data']),
    ...mapGetters('wholesale/saleContract', [
      'getUom',
      'getSalePrice',
      'getCost'
    ]),
    thbRate () {
      let foundFx = this.$store.state.wholesale.saleContract.exchangeRate.find(
        e => e.to_currency == 'THB'
      )
      if (foundFx) {
        return (this.model.fx_rate_thb = parseFloat(foundFx.fx_rate))
      }

      return (this.model.fx_rate_thb = 32)
    },
    numRow () {
      return this.model.item_list.length
    },
    countQty () {
      return _.sumBy(this.model.item_list, 'quantity')
    },
    sumTHBPrice () {
      return _.sumBy(this.model.item_list, 'amount_in_bath')
    },
    sumUSDPrice () {
      return _.sumBy(this.model.item_list, 'unit_price')
    },
    totalAmountUSDPrice () {
      return _.sumBy(this.model.item_list, 'amount')
    },
    locationAssign () {
      return this.$store.state.authUser.user.warehouses
        .filter(w => !w.pivot.is_default)
        .map(el => el.location_id)
    },
    default_currency_sign(){
      return this.$store.state.authUser.sys_setting.default_currency_sign
    }
  },
  created () {
    this.model = this.value
  },
  methods: {
    addNewRow () {
      this.model.item_list.push(_.clone(this.newRow))
    },
    viewPrice (row) {
      // this.product_id = row.product_id
      this.selectedProduct = row
      this.show_modal_sold_price = true
    },
    removeRow (row) {
      this.model.item_list.splice(this.model.item_list.indexOf(row), 1)
      this.calculate()
    },
    onUomChange (row) {
      row.unit_price = this.getSalePrice({
        product_id: row.product_id,
        uom_id: row.uom_id
      })
      row.cost = this.getCost({
        product_id: row.product_id,
        uom_id: row.uom_id
      })
      this.calculate()
    },
    onThbInput (row) {
      row.unit_price = row.amount_in_bath / this.thbRate
      this.calculate()
    },
    onUpUsdInput (row) {
      row.amount_in_bath = row.unit_price * this.thbRate
      this.calculate()
    },

    calculate () {
      if (this.model.item_list.length > 0) {
        this.model.item_list.forEach(el => {
          el.amount = el.quantity * el.unit_price
        })
        var sum = _.sumBy(this.model.item_list, o => o.amount)
        this.model.vat_amount = sum * (this.model.vat_rate / 100)
        var total = this.model.vat_amount + sum
        this.model.total_exclude_vat = total - this.model.vat_amount

        this.model.grand_total = total - this.model.deposit_amount
      }
    },
    onUomEnter (index) {
      this.addNewRow()
      this.$nextTick(() => {
        this.$refs.product[index + 1].focus()
      })
    },
    onRemarkEnter (index) {
      this.addNewRow()
      this.$nextTick(() => {
        this.$refs.product[index + 1].focus()
      })
    },
    onQtyEnter (index) {
      this.$nextTick(() => {
        this.$refs.uom[index].focus()
      })
    },
    priceChange () {
      let row = this.model.item_list.find(e => e.product_id == this.product_id)
      this.onUpUsdInput(row)
    },
    getProductBalance () {
      var product = this.model.item_list.filter(
        item =>
          !includes(
            this.balances.map(el => el.product_id),
            item.product_id
          )
      )
      if (product.length) {
        this.$emit('loading', true)
        this.$store
          .dispatch('wholesale/saleContract/getBalance', {
            product_id: product.map(el => el.product_id)
          })
          .then(response => {
            product.forEach(
              el =>
                (el.balance = response.data.find(
                  p => p.product_id == el.product_id
                ).ending_balance)
            )
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.$emit('loading', false)
          })
      }
    },
    showBalance (record) {
      this.show_modal_balance = true
      this.show_modal_balance_loading = true
      this.$emit('loading', true)
      this.$store
        .dispatch('wholesale/saleContract/getBalance', {
          product_id: [record.product_id],
          location_id: this.locationAssign
        })
        .then(response => {
          this.balanceOtherLocation = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.show_modal_balance_loading = false
          this.$emit('loading', false)
        })
    }
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style scoped>
.max-h {
  /* height: 500px; */
  max-height: 450px;
  overflow: scroll;
}
table {
  /* white-space: nowrap; */
  margin: 0;
  border: none;
  border-collapse: separate;
  border-spacing: 0;
  /* table-layout: fixed; */
  /* border: 1px solid black; */
}
table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: rgb(22, 102, 145);
  color: white;
}
table tfoot {
  position: sticky;
  bottom: 0;
  z-index: 1;
  background-color: white;
}
</style>
